import CourseList from './course-list';

export default CourseList;
